import Mixin from './../../utils/mixin';

const shopSetting = window.shopSetting;
const loadState = () => ({
    appName: shopSetting.appName,
    appMetaTitle: shopSetting.appMetaTitle,
    appLogo: shopSetting.appLogo,
    appUrl: shopSetting.appUrl,
    demoMode: shopSetting.demoMode,
    appLanguage: shopSetting.appLanguage,
    paymentMethods: shopSetting.paymentMethods,
    offlinePaymentMethods: shopSetting.offlinePaymentMethods,
    userLanguage:
        localStorage.getItem('shopSelectedLanguage') || //
        shopSetting.appLanguage,
    availableCountries:
        shopSetting.availableCountries.length > 0 //
            ? shopSetting.availableCountries
            : ['KR'],
    allLanguages: shopSetting.allLanguages,
    allCurrencies: shopSetting.allCurrencies,
    systemSettings: shopSetting.system_settings,
    generalSettings: shopSetting.general_settings,
    headerSettings: {},
    footerSettings: {},
    addons: shopSetting.addons,
    banners: shopSetting.banners,
    apiPath: '/api/v1/',
    routerLoading: true,
    refundSettings: shopSetting.refundSettings,
    productQuerries: [],
    unseenProductQuerries: 0,
    tossPaymentMethods: shopSetting.tossPaymentMethods,
    uploadPercent: 0,
    isMobile: false,
    sidebarColor: null,
    sidebarFontColor: null,
    logoBgColor: null,
    currentCategoryImage: null,
    currentCategoryName: null,
});
export default {
    namespaced: true,
    state: loadState(),
    getters: {
        appName(state) {
            return state.appName;
        },
        appMetaTitle(state) {
            return state.appMetaTitle;
        },
        appLogo(state) {
            return state.appLogo;
        },
        sidebarColor(state) {
            return state.sidebarColor;
        },
        sidebarFontColor(state) {
            return state.sidebarFontColor;
        },
        logoBgColor(state) {
            return state.logoBgColor;
        },
        appUrl(state) {
            return state.appUrl.slice(-1) == '/' ? state.appUrl.slice(0, state.appUrl.length - 1) : state.appUrl;
        },
        demoMode(state) {
            return state.demoMode;
        },
        apiPath(state) {
            return state.apiPath;
        },
        appLanguage(state) {
            return state.appLanguage;
        },
        userLanguage(state) {
            return state.userLanguage;
        },
        userLanguageObj(state) {
            return state.allLanguages.find((language) => language.code === state.userLanguage);
        },
        paymentMethods(state) {
            return state.paymentMethods;
        },
        offlinePaymentMethods(state) {
            return state.offlinePaymentMethods;
        },
        availableCountries(state) {
            return state.availableCountries;
        },
        allLanguages(state) {
            return state.allLanguages;
        },
        allCurrencies(state) {
            return state.allCurrencies;
        },
        systemSettings(state) {
            return state.systemSettings;
        },
        generalSettings(state) {
            return state.generalSettings;
        },
        getHeaderSettings(state) {
            return state.headerSettings;
        },
        getFooterSettings(state) {
            return state.footerSettings;
        },
        banners(state) {
            return state.banners;
        },
        addons(state) {
            return state.addons;
        },
        routerLoading(state) {
            return state.routerLoading;
        },
        refundSettings(state) {
            return state.refundSettings;
        },
        getProductQuerries(state) {
            return state.productQuerries;
        },
        getUnseenProductQuerries(state) {
            return state.unseenProductQuerries;
        },
        tossPaymentMethods(state) {
            return state.tossPaymentMethods;
        },
        getUploadPercent(state) {
            return state.uploadPercent;
        },
        getIsMobile(state) {
            return state.isMobile;
        },
        currentCategoryImage(state) {
            return state.currentCategoryImage;
        },
        currentCategoryName(state) {
            return state.currentCategoryName;
        },
    },
    mutations: {
        setProductQuerries(state, data) {
            state.productQuerries = data;
            let unseenData = data.filter((data) => {
                return data.sender_viewed == 0;
            });
            state.unseenProductQuerries = unseenData.length;
        },
        setLanguage(state, lang) {
            if (state.userLanguage !== lang) {
                state.userLanguage = lang;

                localStorage.removeItem('shopSelectedLanguage');
                localStorage.setItem('shopSelectedLanguage', lang);
            }
        },
        removeLanguage(state) {
            state.userLanguage = state.appLanguage;
            localStorage.removeItem('shopSelectedLanguage');
        },
        setRouterLoading(state, status) {
            state.routerLoading = status;
        },
        setUploadPercent(state, percent) {
            state.uploadPercent = percent;
        },
        setIsMobile(state, isMobile) {
            state.isMobile = isMobile;
        },
        setHeaderSettings(state, data) {
            state.headerSettings = data;
        },
        setFooterSettings(state, data) {
            state.footerSettings = data;
        },
        setAppLogo(state, logo) {
            if (logo) {
                state.appLogo = logo;
            }
        },
        resetAppLogo(state) {
            state.appLogo = shopSetting.appLogo;
        },
        setCurrentCategory(state, { image, name }) {
            state.currentCategoryImage = image || null;
            state.currentCategoryName = name || null;
        },
        clearCurrentCategory(state) {
            state.currentCategoryImage = null;
            state.currentCategoryName = null;
        },
        setSidebarColor(state, color) {
            state.sidebarColor = color || null;
        },
        setSidebarFontColor(state, color) {
            state.sidebarFontColor = color || null;
        },
        setLogoBgColor(state, color) {
            state.logoBgColor = color || null;
        },
    },
    actions: {
        setLanguage({ commit }, lang) {
            commit('setLanguage', lang);
        },
        setUploadPercent({ commit }, percent) {
            commit('setUploadPercent', percent);
        },
        removeLanguage({ commit }) {
            commit('removeLanguage');
        },
        async fetchProductQuerries({ commit }) {
            if (this.getters['auth/isAuthenticated']) {
                const res = await Mixin.methods.call_api('get', `user/querries`);
                if (res.data.success) {
                    commit('setProductQuerries', res.data.data);
                }
            }
        },
    },
};
